module.exports = __webpack_public_path__ + "static/media/645JamesPBrawleyDr_2018-06-12_184.66383607.jpg";